var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoHappAzul(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 43,
    viewBox: "0 0 40 43",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2_13)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.9222 13.4718L20.0553 14.3647L19.1883 13.4718C16.9803 11.1923 13.3882 10.8225 10.977 12.8743C8.21355 15.2306 8.06906 19.456 10.5413 22.0107L19.0551 30.7909C19.606 31.3568 20.4978 31.3568 21.0487 30.7909L29.5625 22.0107C32.0393 19.4583 31.8948 15.2306 29.1313 12.8743C26.7201 10.8225 23.1348 11.1923 20.92 13.4718H20.9222Z",
    fill: "#00FFD4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.4659 0.502437C19.4502 0.094321 20.5565 0.094321 21.5409 0.502437L37.5413 7.16082C39.0247 7.77638 40 9.23297 40 10.8474C40 29.2645 28.6753 39.526 21.5341 42.4978C20.5498 42.9059 19.4435 42.9059 18.4591 42.4978C9.54112 38.7865 0 27.366 0 10.8474C0 9.23297 0.975334 7.77638 2.46769 7.16082L18.4659 0.502437ZM20.92 13.472L20.0531 14.3649L19.1861 13.472C16.978 11.1924 13.386 10.8226 10.9748 12.8744C8.21132 15.2307 8.06683 19.4562 10.539 22.0108L19.0529 30.791C19.6038 31.3569 20.4956 31.3569 21.0465 30.791L29.5603 22.0108C32.037 19.4584 31.8925 15.2307 29.1291 12.8744C26.7178 10.8226 23.1326 11.1924 20.9178 13.472H20.92Z",
    fill: "#0050FF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2_13"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 42.6087,
    fill: "white",
    transform: "translate(0 0.195679)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoHappAzul);
export default __webpack_public_path__ + "static/media/logo-happ-azul.4f063b6c7fb21b02d358dbf0b2155aa8.svg";
export { ForwardRef as ReactComponent };